const COOKIE = 'nowtarot_chart';
const MAX_AGE = 60 * 60 * 24 * 365;
const FIRST_SEEN = 'nowtarot_first_seen';
const LAST_DAILY = 'nowtarot_daily_last';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

function cookieValue() {
  const row = document.cookie.split('; ').find((part) => part.startsWith(`${COOKIE}=`));
  return row ? row.slice(COOKIE.length + 1) : '';
}

export function readSavedChart() {
  try {
    const raw = cookieValue();
    if (!raw) return null;
    const data = JSON.parse(decodeURIComponent(raw));
    if (!data || data.v !== 1 || !data.birth || !data.birth.year || !data.birth.place_label) return null;
    return data.birth;
  } catch {
    return null;
  }
}

export function writeSavedChart(birth) {
  if (!birth || !birth.year || !birth.place_label || birth.latitude == null) return;
  const payload = {
    v: 1,
    saved_at: Date.now(),
    birth: {
      name: birth.name || '',
      year: birth.year,
      month: birth.month,
      day: birth.day,
      hour: birth.hour ?? null,
      minute: birth.minute ?? null,
      time_unknown: Boolean(birth.time_unknown),
      latitude: birth.latitude,
      longitude: birth.longitude,
      timezone: birth.timezone,
      place_label: birth.place_label,
    },
  };
  const value = encodeURIComponent(JSON.stringify(payload));
  if (value.length > 3800) return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${value}; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${secure}`;
}

export function forgetSavedChart() {
  document.cookie = `${COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export function chartSummary(birth) {
  if (!birth) return '';
  const date = `${birth.day} ${MONTHS[(birth.month || 1) - 1]} ${birth.year}`;
  let time = 'time unknown';
  if (!birth.time_unknown && birth.hour != null) {
    const suffix = birth.hour >= 12 ? 'PM' : 'AM';
    const hour = birth.hour % 12 || 12;
    time = `${hour}:${String(birth.minute || 0).padStart(2, '0')} ${suffix}`;
  }
  return [birth.name, date, time, birth.place_label].filter(Boolean).join(' · ');
}

export function firstSeenAt() {
  let first = Date.now();
  try {
    const saved = Number(localStorage.getItem(FIRST_SEEN));
    if (saved) first = saved;
    else localStorage.setItem(FIRST_SEEN, String(first));
  } catch {
    // private mode
  }
  return first;
}

export function dailyVisitMeta() {
  const first = firstSeenAt();
  let daysSinceLast = null;
  try {
    const last = Number(localStorage.getItem(LAST_DAILY));
    if (last) daysSinceLast = Math.max(0, Math.round((Date.now() - last) / 86400000));
  } catch {
    // private mode
  }
  return {
    days_since_first_seen: Math.max(0, Math.floor((Date.now() - first) / 86400000)),
    days_since_last_daily: daysSinceLast,
  };
}

export function markDailyVisit() {
  try {
    localStorage.setItem(LAST_DAILY, String(Date.now()));
  } catch {
    // private mode
  }
}
